import React from "react";
import { Button, IconButton, Snackbar, Theme } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

import "./MessageBox.css";
import makeStyles from "@material-ui/core/styles/makeStyles";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  }
}));

const Message = (props: any) => {
  const classes = useStyles();

  const action = (
    <>
      <Button color="primary" size="small" onClick={async () => props.action()}>
        {props.actionText}
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={props.onClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div className={classes.root}>
      <Snackbar
        className="MessageBox-container"
        open={props.message !== ""}
        onClose={props.onClose}
      >
        <Alert severity={props.severity}>
          <div className="EntityId" data-entity-id={props.entityId}>
            {props.message}
          </div>
          {props.actionText && action}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Message;
